/* eslint-disable no-undef */
import SETTINGS from '../../settings';

const TAG = 'GTAG';

function track(event, data) {
  try {
    gtag('event', event, data);
  } catch (error) {
    // GTAG should not be defined
    setTimeout(() => {
      try {
        gtag('event', event, data);
      } catch (e) {
        console.log(TAG, event, error);
      }
    }, 3000);
  }
}

const Gtag = {
  pageView() {
    track('page_view');
  },

  productView(sku, name, price, currency) {
    track("view_item", {
      currency,
      value: price,
      items: [
        {
          item_id: sku,
          item_name: sku,
          index: 0,
          price,
          quantity: 1,
        }
      ]
    })
  },

  cartItemAdd(sku, name, price, currency) {
    track("add_to_cart", {
      currency,
      value: price,
      items: [
        {
          item_id: sku,
          item_name: sku,
          index: 0,
          price,
          quantity: 1,
        }
      ]
    })

    track('conversion', { send_to: `${SETTINGS.SCRIPTS.GTAG_ID_CONVERSION}/ieyICNnI9NoBEIPr_LcC` });
  },

  checkoutInit(price, currency, promoCode, items) {
    track('begin_checkout', {
      currency,
      value: price,
      coupon: promoCode ? promoCode : undefined,
      items: items.map((item, index) => (
        {
          item_id: item.id,
          item_name: item.id,
          index,
          price: item.product.price,
          quantity: item.quantity,
        }
      ))
    });
  },

  orderSend(price, currency, externalOrderId, promoCode, shipping, items) {
    track("purchase", {
      transaction_id: externalOrderId,
      value: price,
      currency,
      coupon: promoCode ? promoCode : undefined,
      shipping,
      items: items.map((item, index) => (
        {
          item_id: item.id,
          item_name: item.id,
          index,
          price: item.single,
          quantity: item.quantity,
        }
      ))
    })

    track('conversion', {
      send_to: `${SETTINGS.SCRIPTS.GTAG_ID_CONVERSION}/QRCmCL-ugtsBEIPr_LcC`,
      value: price,
      currency,
      transaction_id: externalOrderId,
    });
  },

  customEvent(action, label = undefined, category = undefined, value = undefined) {
    track(action, {
      event_label: label,
      event_category: category,
      value,
    });
  },
};

export default Gtag;
